module.exports = __webpack_public_path__ + "static/media/antena3.a105af8b.png";